module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eOypZ"))).then(() => module.bundle.root('ikE14'));